import { UIElement } from '../ui-element.js';
import { Component } from '../../decorators/component.decorator.js';
import { Child } from '../../decorators/child.decorator.js';
import { Deprecated } from '../../decorators/deprecated.decorator.js';
import styles from './ui-awarddetails.css';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UIAwardDetails
 * @element ui-awarddetails
 * @classdesc Represents a class for <code>ui-awarddetails</code> element.
 * Detailed view of award of offer or reward program in iBank.
 * @property {HTMLButtonElement} previousButton - {@readonly} Shortcut to previous button.
 * @property {HTMLButtonElement} nextButton - {@readonly} Shortcut to next button.
 * @example
 * <ui-awarddetails></ui-awarddetails>
 */
@Component({
    tag: 'ui-awarddetails',
    styles,
})
export class UIAwardDetails extends UIElement {
    @Deprecated('use previousButton property instead')
    @Child('button.-prev')
    prevBtn!: HTMLButtonElement;
    @Deprecated('use nextButton property instead')
    @Child('button.-next')
    nextBtn!: HTMLButtonElement;

    @Child('button.-next') previousButton!: HTMLButtonElement;
    @Child('button.-next') nextButton!: HTMLButtonElement;
}
